<template>
  <div class="d-flex align-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          class="ml-1"
          color="blue-grey lighten-3"
          aria-label="Editar período"
          v-bind="attrs"
          v-on="on"
          @click="$emit('editar')"
        >
          <v-icon small>{{ congelado ? "fa fa-eye" : "fa fa-edit" }}</v-icon>
        </v-btn>
      </template>
      <span>{{ congelado ? "Ver período (bloqueado para edição)" : "Editar período" }}</span>
    </v-tooltip>

    <v-tooltip v-if="podeAtualizar" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          class="ml-1"
          :color="periodo.ativo ? 'warning' : 'success'"
          :aria-label="periodo.ativo ? 'Desativar período' : 'Ativar período'"
          v-bind="attrs"
          v-on="on"
          @click="$emit('alternar-situacao')"
        >
          <v-icon small>{{ periodo.ativo ? "fa fa-pause" : "fa fa-play" }}</v-icon>
        </v-btn>
      </template>
      <span>{{ periodo.ativo ? "Desativar período" : "Ativar período" }}</span>
    </v-tooltip>

    <v-tooltip v-if="podeExcluir" bottom>
      <template v-slot:activator="{ on, attrs }">
        <!-- span: botão desabilitado não dispara o tooltip que explica o motivo -->
        <span v-bind="attrs" v-on="on">
          <v-btn
            x-small
            class="ml-1"
            color="error"
            aria-label="Excluir período"
            :disabled="congelado"
            @click="$emit('excluir')"
          >
            <v-icon small>fa fa-trash</v-icon>
          </v-btn>
        </span>
      </template>
      <span>
        {{
          congelado
            ? "O período tem pré-matrículas e não pode ser excluído. Desative-o."
            : "Excluir período"
        }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "EAcoesDoPeriodo",
  props: {
    periodo: { type: Object, required: true },
    congelado: { type: Boolean, default: false },
  },
  computed: {
    podeAtualizar() {
      return this.$can(["preMatriculaPeriodos.atualizar", "preMatriculaPeriodos.*"]);
    },
    podeExcluir() {
      return this.$can(["preMatriculaPeriodos.excluir", "preMatriculaPeriodos.*"]);
    },
  },
};
</script>
